import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useGroupApi } from "../groupApi";
import { Sheet } from "./ui";
import GroupForm, { groupFormData } from "./GroupForm";

export default function CreateGroupSheet({ onClose }) {
  const { call } = useGroupApi();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const create = async (values) => {
    setBusy(true);
    try {
      const g = await call("groups", { method: "POST", body: groupFormData(values) });
      toast.success("گروه ساخته شد");
      navigate(`/groups/${g.group_id}`);
      onClose();
    } catch (e) {
      toast.error(e.message);
      setBusy(false);
    }
  };

  return (
    <Sheet title="ساخت گروه جدید" onClose={() => !busy && onClose()}>
      <GroupForm submitLabel="ساخت گروه" busy={busy} onSubmit={create} />
    </Sheet>
  );
}
